// eslint complains that we're using isMounted in this file, but it's a false positive
// Remove it as soon as the issue is resolved: https://github.com/jsx-eslint/eslint-plugin-react/issues/3819

import { ModalName } from '@/constants';

function parseUrlHash(url: string | undefined) {
    if (!url || url.indexOf('#') === -1) {
        return '';
    }

    return url.split('#')[1];
}

function preventBodyScrollIfNecessary() {
    try {
        const hash = parseUrlHash(window.top?.location.hash); // This can throw if window.top is a cross-origin window (Payload Live Preview)
        if (hash && document.querySelector(`.modal#${hash}`)) {
            document.body.classList.add('modal-open');
            document.documentElement.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
            document.documentElement.classList.remove('modal-open');
        }
    } catch {
        // NOOP
    }
}

function removeClosedModalHashIfNecessary() {
    try {
        const hash = parseUrlHash(window.top?.location.hash); // This can throw if window.top is a cross-origin window (Payload Live Preview).
        if (hash === ModalName.MODAL_CLOSED) {
            // TODO: Refactor this to use next/router.
            // It would probably require rewriting the whole modal manager, but it seems that it became redundant any way.
            history.replaceState({}, document.title, window.location.href.split('#')[0]);
        }
    } catch {
        // Nothing
    }
}

/**
 * Helper functions used to work with the modals.
 * The modal is implemented using the CSS `:target` selector,
 * which works without JS. This file makes it easier to show/hide
 * a modal within JS.
 */
export const modalManager = {
    isOpen(modalId: string) {
        return window.top?.location.hash === `#${modalId}`;
    },

    onToggle(modalId: string, { onOpen, onClose }: { onOpen: () => void; onClose: () => void }) {
        window.addEventListener('hashchange', (event: HashChangeEvent) => {
            const oldHash = parseUrlHash(event.oldURL);
            const newHash = parseUrlHash(event.newURL);

            if (newHash === modalId && typeof onOpen === 'function') {
                onOpen();
            }
            if (oldHash === modalId && typeof onClose === 'function') {
                onClose();
            }
        });
    },

    show(modalId: string) {
        if (typeof modalId === 'string' && window.top) {
            window.top.location.hash = modalId;
        }
    },

    hide() {
        this.show(ModalName.MODAL_CLOSED);
    },

    initialize() {
        // Hide the modal on esc
        // There is also the close button and backdrop to dismiss the modal,
        // which work without JS. This makes the UX a bit nicer.
        window.addEventListener('keydown', (event) => {
            const { key } = event;
            if (key === 'Escape' || key === 'Esc') {
                this.hide();
            }
        });

        window.addEventListener('hashchange', () => {
            preventBodyScrollIfNecessary();
            removeClosedModalHashIfNecessary();
        });
        preventBodyScrollIfNecessary();
        removeClosedModalHashIfNecessary();
    },

    preventBodyScrollIfNecessary,
};
